import { Form } from '@/src/components/external/Form/Form';
import { FormInput } from '@/src/components/external/Form/FormInput/FormInput';
import { Alert, Box, Button, Grow, Stack, Typography } from '@mui/material';
import Link from 'next/link';
import React from 'react';
import { useFormContext } from 'react-hook-form';

/**
 * The form for the PrivacyPolicy.tsx componet
 * @returns Component
 */
export const DeletionForm = () => {

    // FORM
    const { formState: { isSubmitSuccessful, isSubmitting, errors } } = useFormContext();

    return (
        <Box height={'100%'} display={'flex'} flexDirection={'column'} gap={2}>
            <Typography variant={'bodyGrey'}>
            We're sorry to see you go. If you want to delete your account and all associated data, please enter your details below to submit your request.<br />
            </Typography>

            {/* FIELDS */}
            <Box>
                <FormInput 
                    label={'Player Name'} 
                    name={'player'}
                    disabled={isSubmitting || isSubmitSuccessful}
                />

                <FormInput
                    label={'Team Name'}
                    name={'team'}
                    disabled={isSubmitting || isSubmitSuccessful}
                />

                <FormInput
                    label={'Client Name'}
                    name={'client'}
                    disabled={isSubmitting || isSubmitSuccessful}
                />

                {/* ERROR */}
                {!!errors['api'] && (
                    <Grow in={!!errors['api']}>
                        <Alert 
                            severity={'error'}
                            variant='filled'
                            >
                            {errors['api']?.message as string || 'An unknown error has occurred'}
                        </Alert>
                    </Grow>
                )}
            </Box>
           
            {/* CONTROLS */}
            <Stack direction={'row'} alignItems={'center'} gap={1} mt={3}>
                <Button color='secondary' disabled={isSubmitting || isSubmitSuccessful} type='submit' variant='contained'>Submit</Button> 
            </Stack>
        </Box>
    )

}
